<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
  },
  methods: {
    reload() {
      console.log(123);
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      }, 1000);
    },
  },
};
</script>

<style>
/* 样式初始化开始 */
* {
  font-family: "Microsoft YaHei";
}

.el-select-dropdown {
  background: #161414 !important;
  border: unset !important;
  box-shadow: unset !important;
}

.el-scrollbar {
  background: #161414 !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: unset !important;
}

.van-cell-group {
  background: #110E31 !important;
}

.van-cell {
  background: #110E31 !important;
}

#app>div {
  background: #020017 !important;
}

body {
  font-size: 16px;
  font-family: "微软雅黑";
  background: #020017 !important;
  position: relative;
  margin: 0;
  padding: 0 !important;
}

.el-popup-parent--hidden {
  overflow: unset !important;
}

ul,
li {
  list-style: none;
}

.van-field__control {
  color: #ffffff !important;
}

a {
  text-decoration: none;
  color: #676767;
}

input,
button {
  list-style-type: none;
  border: 0px;
  outline: none;
}

.left {
  float: left !important;
}

.right {
  float: right !important;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: "";
  width: 0;
  height: 0;
  clear: both;
  display: block;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

/* 样式初始化结束 */
</style>



// WEBPACK FOOTER //
// src/App.vue